import React from 'react';

const ViewContext = React.createContext();

export { ViewContext as default };
